export default function DownIcon() {
  return (
    <svg
      width="8"
      height="4"
      viewBox="0 0 8 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0L2.82197 3.49489C3.22222 3.99059 3.97778 3.99059 4.37803 3.49489L7.2 0H0Z"
        fill="currentColor"
      />
      <mask
        id="mask0_1501_1411"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="8"
        height="4"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0L2.82197 3.49489C3.22222 3.99059 3.97778 3.99059 4.37803 3.49489L7.2 0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1501_1411)" />
    </svg>
  );
}
